<template>
  <a v-if="bannerInfo"
     :href="bannerInfo.url[language]"
     :style="{ height: bannerHeight + 'px', backgroundColor: bannerInfo.backgroundColor }"
     @click="handleRedirect($event, bannerInfo.url[language])"
     class="page-header__info header-info">
    <picture>
      <source :style="{ height: bannerHeight + 'px' }"
              class="header-info__img"
              :srcset="bannerInfo.webpMob[language]"
              type="webp"
              media="(max-width: 1024px)">
      <source :style="{ height: bannerHeight + 'px' }"
              class="header-info__img"
              :srcset="bannerInfo.bgMob[language]"
              media="(max-width: 1024px)">
      <source :style="{ height: bannerHeight + 'px' }"
              class="header-info__img"
              :srcset="bannerInfo.webp[language]"
              type="webp">
      <source :style="{ height: bannerHeight + 'px' }" class="header-info__img" :srcset="bannerInfo.bg[language]">
      <img :style="{ height: bannerHeight + 'px' }"
           class="header-info__img"
           :src="backgroundImage"
           alt="header-info">
    </picture>
  </a>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { GoogleEnhancedEcommerce } from '@/services/AnalyticService'

export default {
  name: 'HeaderBanner',
  props: {
    bannerInfo: Object
  },
  data () {
    return {
      innerWidth: null
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapState({
      language: state => state.translation.language
    }),
    backgroundImage () {
      if (this.innerWidth < 1024) {
        return this.bannerInfo.bgMob[this.language]
      } else {
        return this.bannerInfo.bg[this.language]
      }
    },
    bannerHeight () {
      if (this.innerWidth < 1024) {
        return this.bannerInfo.heightMob
      } else {
        return this.bannerInfo.height
      }
    },
    dataForAnalytics () {
      const img = this.bannerInfo.bg[this.language]
      const fileName = img.substring(img.lastIndexOf('/') + 1)
      const imgName = fileName.split('.')[0]
      return {
        promotion_id: this.bannerInfo.banner_id.toString() || '', // якщо доступне значення
        promotion_name: imgName, // ім'я баннера https://imgur.com/VHwAxqr
        creative_slot: 'header_info', // місце розташування слайдера
        index: 1, // порядковый номер баннера
        universal_value: this.bannerInfo.bg[this.language], // лінк на баннер
        banner_link: this.bannerInfo.url[this.language]
      }
    }
  },
  methods: {
    async handleRedirect (e, link) {
      e.preventDefault()
      if (GoogleEnhancedEcommerce.isEnabled && this.bannerInfo) {
        const savedBanners = localStorage.getItem('clickedBanners')
        const hasBanner = savedBanners && JSON.parse(savedBanners).find(el => el.promotion_id.toString() === this.bannerInfo.banner_id.toString())
        if (!hasBanner) {
          const allClickedBanners = savedBanners ? JSON.parse(savedBanners) : []
          allClickedBanners.push(this.dataForAnalytics)
          localStorage.setItem('clickedBanners', JSON.stringify(allClickedBanners))
        }
        GoogleEnhancedEcommerce.selectPromotion(this.dataForAnalytics)
      }
      location.href = link
    }
  },
  mounted () {
    this.innerWidth = window.innerWidth

    window.addEventListener('resize', () => {
      this.innerWidth = window.innerWidth
    })

    if (GoogleEnhancedEcommerce.isEnabled && this.bannerInfo) {
      GoogleEnhancedEcommerce.viewPromotion(this.dataForAnalytics)
    }
  }
}
</script>

<style lang="sass">
.page-header__main .header-info
  display: flex !important
  +mmin(1024)
    display: none !important
</style>

<style scoped lang="sass">

.header-info
  order: 0
  justify-content: center
  min-height: 36px
  display: none

  +mmin(1024)
    min-height: 45px
    order: 1
    display: flex

.header-info__img
  object-fit: cover

</style>
